import Vue from "vue";
import App from "./App.vue";
import store from "./store/store"; //引入状态管理 store
import ElementUI from "element-ui";
import router from "./config/router.js";
import Axios from "./config/axios";
import "element-ui/lib/theme-chalk/index.css";
import "../public/css/main.css";
import echarts from "echarts";
import './iconFont/iconfont.css';
import directives from '@/config/directives.js'
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$ajax = Axios;
Vue.prototype.$echarts = echarts;
Vue.use(directives);
router.beforeEach((to, from, next) => {
  let Token = localStorage.getItem("token");
  if (Token) {
    /* has token*/
    if (to.path === "/login") {
      next();
    } else {
      next();
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next({
        path: "/login",
      }); // 否则全部重定向到登录页
    }
  }
});

//权限
// router.beforeEach((to, from, next) => {
//   let authority = localStorage.getItem("permissions");
//   let chatFlag = false;
//   let prescriptionsFlag = false;
//   if (authority) {
//     let Retrieval = JSON.parse(authority);
//     Retrieval.forEach((item) => {
//       switch (item.name) {
//         case "预约问诊":
//           chatFlag = true;
//           break;
//         case "处方记录":
//           prescriptionsFlag = true;
//       }
//     });
//     if (to.path === "/chat") {
//       if (chatFlag === true) {
//         next();
//       } else {
//         alert("用户未拥有该权限");
//       }
//     } else if (to.path === "/prescriptions") {
//       if (prescriptionsFlag === true) {
//         next();
//       } else {
//         alert("用户未拥有该权限");
//       }
//     } else if (to.path === "/login") {
//       next();
//     }
//   }
//   if (to.path === "/login") {
//     next();
//   }
// });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
